module.exports = __webpack_public_path__ + "cad1324b066f52f764cf080d9244c8b2.woff";